exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-b3e016dc],\n.fade-leave-active[data-v-b3e016dc] {\n\ttransition: opacity 0.5s;\n}\n.btn[data-v-b3e016dc] {\n\tmargin-bottom: 8px;\n}\n.fade-enter[data-v-b3e016dc],\n.fade-leave-to[data-v-b3e016dc] {\n\topacity: 0;\n}\n", ""]);

// exports
